import { RouteConfig } from 'vue-router'
import Home from '../views/Chat.vue'
import Offline from '../views/Offline.vue'
import { Store } from 'vuex'
import ChatBotView from '@/modules/chatbot/views/Chat.vue'

export function createChatBotRoutes (store: Store<any>): RouteConfig[] {
  return [
    {
      path: '/chat',
      name: 'chatbot',
      component: ChatBotView,
      beforeEnter (to, from, next) {
        next()
      }
    }

  ]
}
